import {
  Box,
  Typography,
  List,
  ListItem,
  ListItemButton,
  Link,
} from "@mui/joy";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "../../../i18n";
import {
  useChatDirectConversationsQuery,
  useUserMeQuery,
} from "../../../__generated__/types-and-hooks";
import ConversationListItem, {
  ConversationListItemSkeleton,
} from "./Conversations";
import ChatBubbleOutlineIcon from "@mui/icons-material/ChatBubbleOutlineOutlined";
import { Link as RouterLink } from "react-router-dom";

export interface ConversationsListProps {
  conversationId?: number;
}

export default function ConversationsList({
  conversationId,
}: ConversationsListProps) {
  const navigate = useNavigate();
  const t = useTranslation();
  const userMeQuery = useUserMeQuery();
  const userMe = userMeQuery.data?.user_me;

  const directConversationsQuery = useChatDirectConversationsQuery();
  const conversations =
    directConversationsQuery.data?.chat_direct_conversations;

  return (
    <Box
      sx={{
        borderRadius: 6,
        height: "100%",
        m: 0,
        border: "1px solid hsl(0deg 0% 31.06% / 35%)",
        backgroundColor: "hsl(0deg 0% 31.06% / 35%);",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <Box sx={{ textAlign: "center", mt: 4, color: "neutral.500" }}>
        <Link component={RouterLink} color="primary" to="/network">
          <ChatBubbleOutlineIcon sx={{ fontSize: 48, mb: 2 }} />
        </Link>
        <Typography level="title-md">
          {t("No conversation selected")}
        </Typography>
        <Typography level="body-sm" sx={{ mb: 4 }}>
          {t("Select a conversation from the list or start a new one.")}
        </Typography>

        <List
          sx={{
            py: 0,
            "--ListItem-paddingY": "0.75rem",
            "--ListItem-paddingX": "1rem",
          }}
        >
          {directConversationsQuery.loading && (
            <ListItem
              key={0}
              sx={{
                border: "1px solid var(--joy-palette-neutral-outlinedBorder)",
                borderLeft: 0,
                borderRight: 0,
              }}
            >
              <ListItemButton
                color="neutral"
                sx={{
                  flexDirection: "column",
                  alignItems: "initial",
                  gap: 1,
                }}
              >
                <ConversationListItemSkeleton />
              </ListItemButton>
            </ListItem>
          )}
          {conversations &&
            conversations.map((conversation, index) => (
              <ListItem
                key={index}
                sx={{
                  border: "1px solid var(--joy-palette-neutral-outlinedBorder)",
                  borderLeft: 0,
                  borderRight: 0,
                }}
              >
                <ListItemButton
                  onClick={() => navigate("/messages/" + conversation.id)}
                  selected={conversation.id === conversationId}
                  color="neutral"
                  sx={{
                    flexDirection: "column",
                    alignItems: "initial",
                    gap: 1,
                  }}
                >
                  {userMe &&
                    conversation.users
                      .filter((user) => user.id !== userMe.id)
                      .map((user) => (
                        <ConversationListItem key={user.id} userId={user.id} />
                      ))}
                </ListItemButton>
              </ListItem>
            ))}
        </List>
      </Box>
    </Box>
  );
}
